import * as React from 'react'
import { Col, Row } from 'antd'
import { THEME_COLORS } from '@getgreenline/shared'
import { COLORS } from '@/app/constants/Colors'

interface Props {
  backgroundStyle?: React.CSSProperties
  leftColumn: React.ReactNode
  rightColumn: React.ReactNode
}

export const LoginWrapper = (props: Props) => {
  return (
    <Row
      style={{
        ...styles.backgroundRow,
        ...props.backgroundStyle,
      }}
      type='flex'
      justify='center'
      align='middle'
    >
      <Col sm={16} md={14} lg={20} xl={15} xxl={11} style={styles.wrapperCol}>
        <Row type='flex'>
          <Col xs={24} lg={12} style={styles.mainColLeft}>
            {props.leftColumn}
          </Col>
          <Col xs={24} lg={12} className='login-form' style={styles.mainColRight}>
            {props.rightColumn}
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

const styles: { [key: string]: React.CSSProperties } = {
  backgroundRow: {
    height: '100vh',
    width: '100%',
    backgroundColor: THEME_COLORS.BRAND.black,
    backgroundSize: 'cover',
  },
  wrapperCol: {
    boxShadow: 'rgba(0, 0, 0, 0.3) 4px 4px 16px',
    borderRadius: '10px',
    overflow: 'hidden',
  },
  deviceInfo: { color: THEME_COLORS.MONO.monoFf },
  mainColLeft: {
    backgroundColor: COLORS.BRAND.black,
    alignContent: 'center',
    justifyContent: 'center',
    padding: '1.5rem',
  },
  mainColRight: {
    backgroundColor: THEME_COLORS.MONO.monoFf,
  },
  startFloatInput: {
    fontSize: 14,
    height: 40,
    borderRadius: '4px',
    border: `1px solid ${COLORS.borderGreyC4} !important`,
    backgroundColor: THEME_COLORS.MONO.monoee,
    color: THEME_COLORS.BRAND.blackAlt,
  },
  calcButton: {
    color: THEME_COLORS.BRAND.retailAlt,
    border: 'none',
    background: 'none',
    fontSize: 14,
  },
  startCash: {
    color: THEME_COLORS.BRAND.blackAlt,
  },
  addNotes: { color: THEME_COLORS.BRAND.retailAlt, fontSize: 12 },
  addNotesInput: {
    fontSize: 14,
    height: 40,
    borderRadius: '4px',
    border: `1px solid ${COLORS.borderGreyC4} !important`,
    color: THEME_COLORS.BRAND.blackAlt,
  },
  passcodeInput: {
    fontSize: 14,
    height: 40,
    borderRadius: '4px',
    border: `1px solid ${COLORS.borderGreyC4} !important`,
    color: THEME_COLORS.BRAND.blackAlt,
  },
  buttonGroup: { display: 'flex', flexDirection: 'row' },
  startShiftButtonDisabled: {
    color: THEME_COLORS.MONO.mono99,
    border: `1px solid ${COLORS.borderGreyC4}`,
    backgroundColor: THEME_COLORS.MONO.monodd,
    borderRadius: 4,
    gap: 10,
    fontSize: 14,
  },
  startShiftButtonEnabled: {
    color: THEME_COLORS.MONO.monoFf,
    border: `1px solid ${THEME_COLORS.BRAND.retailAlt}`,
    backgroundColor: THEME_COLORS.BRAND.retailAlt,
    borderRadius: 4,
    gap: 10,
    fontSize: 14,
  },
  lastShiftButtonEnabled: {
    backgroundColor: THEME_COLORS.MONO.monoFf,
    border: `1px solid ${COLORS.borderGreyC4} !important`,
    borderRadius: 4,
    gap: 10,
    color: THEME_COLORS.BRAND.blackAlt,
    fontSize: 14,
  },
  lastShiftButtonDisabled: {
    color: THEME_COLORS.MONO.mono99,
    border: `1px solid ${COLORS.borderGreyC4}`,
    backgroundColor: THEME_COLORS.MONO.monodd,
    borderRadius: 4,
    gap: 10,
    fontSize: 14,
  },
  logout: {
    color: THEME_COLORS.MONO.monoFa,
    backgroundColor: THEME_COLORS.BRAND.black,
    fontSize: 16,
    cursor: 'pointer',
    width: '100%',
    borderRadius: '10px',
  },
  help: {
    border: 1,
    borderRadius: 4,
    borderStyle: 'solid',
    borderColor: THEME_COLORS.BRAND.blackAlt,
    color: THEME_COLORS.BRAND.blackAlt,
    fontSize: 14,
  },
}
